import {
    FETCH_PACK_ORDER_PENDING,
    FETCH_PACK_ORDER_SUCCESS,
    FETCH_PACK_ORDER_FAILED,
    FETCH_PACK_ORDER_ITEMS_PENDING,
    FETCH_PACK_ORDER_ITEMS_SUCCESS,
    FETCH_PACK_ORDER_ITEMS_FAILED,
    PACK_SCAN_RESULT,
    CLEAR_PACK_SCAN_RESULT,
    CLEAR_PACK_VERIFICATION
} from "../types";

const initialState = {
    packOrder: null,
    packOrderStatus: '',
    orderItems: [],
    orderItemsStatus: '',
    lastPackScanResult: null,
};

const PackVerificationReducer = (state = initialState, action = '') => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_PACK_ORDER_PENDING:
            return {
                ...state,
                packOrderStatus: 'PENDING',
                packOrder: null,
            };
        case FETCH_PACK_ORDER_SUCCESS:
            return {
                ...state,
                packOrderStatus: 'SUCCESS',
                packOrder: payload,
            };
        case FETCH_PACK_ORDER_FAILED:
            return {
                ...state,
                packOrderStatus: 'FAILED',
                packOrder: null,
            };
        case FETCH_PACK_ORDER_ITEMS_PENDING:
            return {
                ...state,
                orderItemsStatus: 'PENDING',
                orderItems: [],
            };
        case FETCH_PACK_ORDER_ITEMS_SUCCESS:
            return {
                ...state,
                orderItemsStatus: 'SUCCESS',
                orderItems: payload.orderItems,
            };
        case FETCH_PACK_ORDER_ITEMS_FAILED:
            return {
                ...state,
                orderItemsStatus: 'FAILED',
                orderItems: [],
            };
        case PACK_SCAN_RESULT:
            return {
                ...state,
                lastPackScanResult: payload,
            };
        case CLEAR_PACK_SCAN_RESULT:
            return {
                ...state,
                lastPackScanResult: null,
            };
        case CLEAR_PACK_VERIFICATION:
            return initialState;
        default:
            return state;
    }
};

export default PackVerificationReducer;
